import React, { useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { LangContext } from '../App';

const OR = 'var(--couleur-or)';

const T = {
  fr: {
    title: 'Compte vendeur Stripe',
    soustitre: 'Recevez vos paiements directement sur votre compte bancaire.',
    btnConfigurer: 'Configurer mon compte vendeur Stripe',
    btnTerminer: 'Compléter ma vérification Stripe',
    btnRefresh: 'Actualiser le status',
    statutNonConfig: 'Non configuré',
    statutEnCours: 'Vérification en cours',
    statutVerifie: 'Vérifié ✓',
    chargement: 'Chargement…',
    erreur: 'Erreur de communication avec Stripe.',
    commission: 'Commission ChasseHunt : 10 %',
  },
  en: {
    title: 'Stripe seller account',
    soustitre: 'Receive payments directly into your bank account.',
    btnConfigurer: 'Set up my Stripe seller account',
    btnTerminer: 'Complete my Stripe verification',
    btnRefresh: 'Refresh status',
    statutNonConfig: 'Not configured',
    statutEnCours: 'Verification pending',
    statutVerifie: 'Verified ✓',
    chargement: 'Loading…',
    erreur: 'Stripe communication error.',
    commission: 'ChasseHunt fee: 10%',
  },
};

export default function StripeOnboarding() {
  const { lang } = useContext(LangContext);
  const t = T[lang];

  const [status, setStatut] = useState(null);
  const [chargement, setCharge] = useState(true);
  const [erreur, setErreur] = useState(false);
  const [redirection, setRedir] = useState(false);

  function chargerStatut() {
    setCharge(true);
    api
      .get('/stripe/connect/status')
      .then((r) => {
        setStatut(r.data);
        setErreur(false);
      })
      .catch(() => setErreur(true))
      .finally(() => setCharge(false));
  }

  useEffect(() => {
    chargerStatut();
  }, []);

  function lancerOnboarding() {
    setRedir(true);
    api
      .post('/stripe/connect/onboarding')
      .then((r) => {
        window.location.href = r.data.url;
      })
      .catch(() => {
        setRedir(false);
        setErreur(true);
      });
  }

  let badge;
  if (chargement)
    badge = { txt: t.chargement, bg: 'rgba(255,255,255,0.08)', fg: 'rgba(255,255,255,0.5)' };
  else if (erreur)
    badge = { txt: t.erreur, bg: 'rgba(200,50,50,0.12)', fg: 'var(--couleur-texte-erreur)' };
  else if (status?.verifie)
    badge = { txt: t.statutVerifie, bg: 'rgba(40,160,80,0.15)', fg: 'var(--couleur-texte-succes)' };
  else if (status?.configure)
    badge = { txt: t.statutEnCours, bg: 'rgba(201,162,39,0.12)', fg: 'var(--couleur-or)' };
  else
    badge = { txt: t.statutNonConfig, bg: 'rgba(255,255,255,0.06)', fg: 'rgba(255,255,255,0.55)' };

  const peutOnboard = !chargement && !redirection && !status?.verifie;

  return (
    <div
      data-testid="stripe-onboarding"
      style={{
        background: 'rgba(255,255,255,0.025)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '10px',
        padding: '1.2rem 1.4rem',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '0.8rem',
          flexWrap: 'wrap',
          marginBottom: '0.6rem',
        }}
      >
        <h3
          style={{
            fontFamily: 'Georgia, serif',
            fontSize: '1.05rem',
            color: 'var(--couleur-texte)',
            margin: 0,
          }}
        >
          💳 {t.title}
        </h3>
        <span
          style={{
            fontSize: '0.72rem',
            fontWeight: 600,
            background: badge.bg,
            color: badge.fg,
            border: `1px solid ${badge.fg}55`,
            borderRadius: '20px',
            padding: '3px 12px',
          }}
        >
          {badge.txt}
        </span>
      </div>
      <div
        style={{
          fontSize: '0.85rem',
          color: 'rgba(255,255,255,0.5)',
          marginBottom: '1rem',
          lineHeight: 1.4,
        }}
      >
        {t.soustitre}
        <br />
        <span style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.35)' }}>{t.commission}</span>
      </div>
      <button
        disabled={!peutOnboard}
        onClick={lancerOnboarding}
        style={{
          background: peutOnboard ? OR : 'rgba(255,255,255,0.08)',
          color: peutOnboard ? 'var(--couleur-fond-carte)' : 'rgba(255,255,255,0.35)',
          border: 'none',
          padding: '0.6rem 1.2rem',
          borderRadius: '6px',
          fontSize: '0.85rem',
          fontWeight: 700,
          cursor: peutOnboard ? 'pointer' : 'not-allowed',
          marginRight: '0.6rem',
        }}
      >
        {status?.configure ? t.btnTerminer : t.btnConfigurer}
      </button>
      <button
        onClick={chargerStatut}
        disabled={chargement}
        style={{
          background: 'transparent',
          color: 'rgba(255,255,255,0.55)',
          border: '1px solid rgba(255,255,255,0.18)',
          padding: '0.6rem 1rem',
          borderRadius: '6px',
          fontSize: '0.78rem',
          cursor: chargement ? 'not-allowed' : 'pointer',
        }}
      >
        ↻ {t.btnRefresh}
      </button>
    </div>
  );
}
